export { ReactComponent as Dashboard } from "./Dashboard.svg";
export { ReactComponent as Analytics } from "./Analytics.svg";
export { ReactComponent as Events } from "./Events.svg";
export { ReactComponent as Sales } from "./Sales.svg";
export { ReactComponent as Filters } from "./Filters.svg";
export { ReactComponent as Contacts } from "./Contacts.svg";
export { ReactComponent as Emails } from "./Emails.svg";
export { ReactComponent as Settings } from "./Settings.svg";
export { ReactComponent as Support } from "./Support.svg";
export { ReactComponent as Widgets } from "./Widgets.svg";
export { ReactComponent as CalendarIcon } from "./CalendarIcon.svg";
export { ReactComponent as CalendarIconMenu } from "./CalendarIconMenu.svg";
export { ReactComponent as MapMarkIcon } from "./MapMarkIcon.svg";
export { ReactComponent as Filter } from "./Filter.svg";
export { ReactComponent as BrushIcon } from "./BrushIcon.svg";
export { ReactComponent as TicketIcon } from "./TicketIcon.svg";
export { ReactComponent as UploadIcon } from "./UploadIcon.svg";
export { ReactComponent as CheckMark } from "./CheckMark.svg";
export { ReactComponent as PlusIcon } from "./PlusIcon.svg";
export { ReactComponent as MinusIcon } from "./MinusIcon.svg";
export { ReactComponent as CloseIcon } from "./CloseIcon.svg";
export { ReactComponent as Profile } from "./Profile.svg";
export { ReactComponent as Link } from "./LinkIcon.svg";
export { ReactComponent as Youtube } from "./Youtube.svg";
